import React, { useEffect,useState } from "react";
import close from '../../img/close.png';
import Modal from "react-modal";
import { Variables, variables } from '../../Variables.js';

function formatDate(gameId) {

    const parts = gameId.split('_');
    const date = parts[0];
    const game = parts[1];

    const year = date.substring(2, 4);
    const month = date.substring(4, 6);
    const day = date.substring(6, 8);

    const formattedDate = `${month}/${day}/${year}`;

    return `${formattedDate}`;
}

const fetchPlayerData = async (playerID) => {
    try {
        const response = await fetch(variables.API_URL + 'Stats/getStats/' + playerID);
        if (!response.ok) {
            throw new Error('Failed to fetch player data');
        }
        const data = await response.json();
        return data.espnName; // Adjust this to where the player name is in your response
    } catch (error) {
        console.error("Error fetching player data:", error);
        // You might want to handle this error differently or return a default value
        return 'Unknown Player';
    }
};

const GamesModal = ({ game, onClose }) => {

    const [playerNames, setPlayerNames] = useState({});

    useEffect(() => {
        // Create a unique set of player IDs
        const playerIDs = new Set();
        Object.values(game.topPerformers).forEach(team => {
            Object.values(team).forEach(stat => {
                stat.playerID.forEach(id => playerIDs.add(id));
            });
        });

        // Fetch player names for each ID
        Array.from(playerIDs).forEach(async (playerID) => {
            const playerName = await fetchPlayerData(playerID);
            setPlayerNames(prevPlayerNames => ({
                ...prevPlayerNames,
                [playerID]: playerName
            }));
        });
    }, [game]);

    const constructQueryString = () => {
        const queryParameters = new URLSearchParams(window.location.search);
        let queryStringParts = [];

        // Check for each parameter and add to the array if it exists
        if (queryParameters.has('points')) queryStringParts.push('points=true');
        if (queryParameters.has('rebounds')) queryStringParts.push('rebounds=true');
        if (queryParameters.has('assists')) queryStringParts.push('assists=true');
        if (queryParameters.has('pr')) queryStringParts.push('pr=true');
        if (queryParameters.has('pa')) queryStringParts.push('pa=true');
        if (queryParameters.has('pra')) queryStringParts.push('pra=true');

        // Join the parts with '&' to form the final query string
        return queryStringParts.join('&');
    };

    if (!game) return null;

    const additionalQueryString = constructQueryString();
    const date = formatDate(game.gameID);
   
   

    return (
        <Modal
            isOpen={!!game} // isOpen controls the visibility based on whether game data is present
            onRequestClose={onClose} // onRequestClose is called when the user wants to close the modal
            contentLabel="Top Performers" // contentLabel provides an accessible name for the modal
            style={{
                content: {
                    margin: 'auto',
                    width: '50%',
                    height: 'auto',
                    backgroundColor: "#42423e",
                    overflow: 'auto' // Ensure modal content is scrollable if needed
                }
            }}
        >
            <div>
                
                <img onClick={onClose} className="closeIcon" src={close} alt="Close Icon" />
                <h4 style={{ marginTop: '3%' }}>{date}</h4>
                <h4>Top Performers: {game.away} vs {game.home} {game.gameClock}</h4>
                    {/* Iterate over the topPerformers object to create a table for each team */}
                {Object.entries(game.topPerformers).map(([team, stats]) => {
                    // Determine the playerTeamId based on the team
                    const playerTeamId = team === game.away ? game.teamIDAway : game.teamIDHome;
                    return (
                        <div key={team}>
                            <h4 style={{ marginTop: '3%' }}>{team}</h4>
                            <table className="top-performers-table">
                                <thead>
                                    <tr>
                                        <th>Stat</th>
                                        <th>Value</th>
                                        <th>Player</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(stats).map(([stat, detail]) => (
                                        <tr key={stat}>
                                            <td>{stat.toUpperCase()}</td>
                                            <td>{detail.total}</td>
                                            <td>
                                                {detail.playerID.map((id, index) => (
                                                    <React.Fragment key={id}>
                                                        {index > 0 && ', '}
                                                        <a href={`/stats/?playerName=${playerNames[id]}&playerId=${id}&playerTeamId=${playerTeamId}&playerTeamAbrev=${team}&${additionalQueryString}`} target="_blank" rel="noopener noreferrer">
                                                            {playerNames[id] || 'Loading...'}
                                                        </a>
                                                    </React.Fragment>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    );
                })}
                
            </div>
        </Modal>

    );
};

export default GamesModal;
